import { NAV } from "./data";

export default function Footer() {
  const year = 2025;
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer data-testid="site-footer" className="bg-primary text-primary-foreground">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <div className="flex items-center gap-2">
              <span className="h-2.5 w-2.5 rounded-full bg-accent" />
              <span className="font-serif text-2xl tracking-tight">Align Enrollment Solutions</span>
            </div>
            <p className="mt-6 max-w-md text-sm text-primary-foreground/60 leading-relaxed">
              Medical group and provider payer enrollment, credentialing, and contracting — delivered with clinical
              precision so your providers get in-network, faster.
            </p>
          </div>
          <div className="md:col-span-3">
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-primary-foreground/50">Navigate</span>
            <ul className="mt-5 space-y-3">
              {NAV.map((n) => (
                <li key={n.href}>
                  <button onClick={() => go(n.href)} className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors duration-200">
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-primary-foreground/50">Contact</span>
            <ul className="mt-5 space-y-3 text-sm text-primary-foreground/80">
              <li>hello@alignesllc.com</li>
              <li>(631) 415-1476</li>
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-primary-foreground/15">
          <p className="max-w-4xl text-[11px] leading-relaxed text-primary-foreground/45" data-testid="footer-disclaimer">
            <span className="font-medium text-primary-foreground/60">Disclaimer:</span> Align Enrollment Solutions LLC provides
            administrative enrollment and credentialing support only. We do not guarantee acceptance, approval, effective dates,
            or in-network participation, as those decisions rest solely with the respective insurance payers and government
            programs. Content on this site is for general informational purposes only and is not legal, compliance, medical, or
            billing advice. Package pricing is illustrative and subject to change; final terms are confirmed in a written service
            agreement. References to Medicare, Medicaid, CAQH, PECOS, or any payer are for identification only and do not imply
            affiliation or endorsement. Please do not submit protected health information (PHI) through this website.
          </p>
          <div className="mt-6 flex flex-col md:flex-row items-center justify-between gap-4">
            <span className="font-mono text-xs text-primary-foreground/50">© {year} Align Enrollment Solutions LLC. All rights reserved.</span>
            <span className="font-mono text-xs text-primary-foreground/50">Provider & Payer Enrollment Specialists</span>
          </div>
        </div>
        <div className="mt-6 flex justify-center md:justify-start">
          <a href="/admin" data-testid="staff-login-link" className="font-mono text-[10px] uppercase tracking-[0.2em] text-primary-foreground/40 hover:text-primary-foreground/80 transition-colors duration-200">
            Staff Login
          </a>
        </div>
      </div>
    </footer>
  );
}
